"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataObjectBuilderUtils = void 0;
var realmforge_common_1 = require("realmforge-common");
var realms_engine_1 = require("realms-engine");
var uuid_1 = require("uuid");
var realms_three_1 = __importDefault(require("realms-three"));
var utils_1 = require("../utils");
var DataObjectBuilderUtils = /** @class */ (function () {
    function DataObjectBuilderUtils() {
    }
    /**
     * Creates base data object
     */
    DataObjectBuilderUtils.prototype.createBaseDataObject = function (params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return {
            id: (_a = params.id) !== null && _a !== void 0 ? _a : (0, uuid_1.v4)(),
            parentId: null,
            blueprintId: params.blueprintId,
            name: (_b = params.name) !== null && _b !== void 0 ? _b : params.type,
            visible: true,
            transformation: {
                position: (_d = (_c = params.transformation) === null || _c === void 0 ? void 0 : _c.position) !== null && _d !== void 0 ? _d : (0, realms_engine_1.vector3Zero)(),
                rotation: (_f = (_e = params.transformation) === null || _e === void 0 ? void 0 : _e.rotation) !== null && _f !== void 0 ? _f : (0, realms_engine_1.vector3Zero)(),
                scale: (_h = (_g = params.transformation) === null || _g === void 0 ? void 0 : _g.scale) !== null && _h !== void 0 ? _h : 1,
            },
        };
    };
    /**
     * Updates the base data object
     */
    DataObjectBuilderUtils.prototype.updateBaseDataObject = function (oldDataObject, params) {
        var name = params.name, visible = params.visible, transformation = params.transformation;
        var newDataObject = __assign({}, oldDataObject);
        if (name !== undefined) {
            // Update new
            newDataObject.name = name;
        }
        if (visible !== undefined) {
            // Update new
            newDataObject.visible = visible;
        }
        if ((transformation === null || transformation === void 0 ? void 0 : transformation.position) !== undefined) {
            // Update new
            newDataObject.transformation.position = transformation.position;
        }
        if ((transformation === null || transformation === void 0 ? void 0 : transformation.rotation) !== undefined) {
            // Update new
            newDataObject.transformation.rotation = transformation.rotation;
        }
        if ((transformation === null || transformation === void 0 ? void 0 : transformation.scale) !== undefined) {
            // Update new
            newDataObject.transformation.scale = transformation.scale;
        }
        return newDataObject;
    };
    /**
     * Sets three properties
     */
    DataObjectBuilderUtils.prototype.setThreeProperties = function (params, threeObject) {
        var transformation = params.transformation, visible = params.visible;
        if (transformation === null || transformation === void 0 ? void 0 : transformation.position) {
            threeObject.position.set(transformation.position.x, transformation.position.y, transformation.position.z);
        }
        if (transformation === null || transformation === void 0 ? void 0 : transformation.rotation) {
            threeObject.rotation.set(transformation.rotation.x, transformation.rotation.y, transformation.rotation.z);
        }
        if (transformation === null || transformation === void 0 ? void 0 : transformation.scale) {
            threeObject.scale.set(transformation.scale, transformation.scale, transformation.scale);
        }
        if (visible !== undefined) {
            threeObject.visible = visible;
        }
        return threeObject;
    };
    /**
     * Sets a three objects material
     */
    DataObjectBuilderUtils.prototype.setThreeMaterial = function (params, threeObject, methods) {
        return __awaiter(this, void 0, void 0, function () {
            var oldWireframeValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (params.material === undefined || !(threeObject instanceof realms_three_1.default.Mesh)) {
                            return [2 /*return*/, threeObject];
                        }
                        oldWireframeValue = threeObject.material.wireframe;
                        // Set material
                        return [4 /*yield*/, (0, utils_1.setThreeObjectMaterial)(threeObject, params.material, methods)];
                    case 1:
                        // Set material
                        _a.sent();
                        // Restore old wireframe value
                        threeObject.material.wireframe = oldWireframeValue;
                        return [2 /*return*/, threeObject];
                }
            });
        });
    };
    /**
     * Set three shape properties
     */
    DataObjectBuilderUtils.prototype.setThreeShapeProperties = function (params, threeObject) {
        var shapeProperties = params.shapeProperties;
        // Display as wireframe
        if ((shapeProperties === null || shapeProperties === void 0 ? void 0 : shapeProperties.physicsType) !== undefined &&
            threeObject instanceof realms_three_1.default.Mesh) {
            threeObject.material.wireframe =
                shapeProperties.physicsType === realmforge_common_1.PhysicsType.Invisible;
        }
        return threeObject;
    };
    return DataObjectBuilderUtils;
}());
exports.DataObjectBuilderUtils = DataObjectBuilderUtils;
